import { getField, updateField } from 'vuex-map-fields'
import getInvoiceFiltersModel from './models/invoiceFilters'

const nextDay = (dateString) => {
  const date = new Date(`${dateString.substr(0, 10)}T00:00:00Z`)
  date.setUTCDate(date.getUTCDate() + 1)
  return date.toISOString().substr(0, 10)
}

const invoiceFilters = {
  namespaced: true,
  state: {
    ...getInvoiceFiltersModel()
  },
  getters: {
    getField,
    // The API takes an exclusive end date, so the picked To date is sent as the day after it.
    getSearchObject (state) {
      const search = {}
      if (state.clientId) search.clientId = state.clientId
      if (state.postingStateId) search.postingStateId = state.postingStateId
      if (state.submittedFrom) search.submittedOnOrAfter = state.submittedFrom.substr(0, 10)
      if (state.submittedTo) search.submittedBefore = nextDay(state.submittedTo)
      return search
    }
  },
  actions: {
    clearFilters ({ commit }) {
      return commit('clearFilters')
    }
  },
  mutations: {
    updateField,
    clearFilters (state) {
      const model = getInvoiceFiltersModel()
      Object.keys(model).forEach(key => { state[key] = model[key] })
    }
  }
}

export default invoiceFilters
